<template>
  <div class="column full-height">
    <h4 class="text-grey-10 text-center text-weight-medium word-break">
      Welcome {{ name ? `${name}!` : '!' }}
    </h4>
    <p class="text-center q-mt-sm">
      To access your employer benefits, enter your company details below.
    </p>
    <SAIFormError
      class="q-mt-md"
      v-if="nameError.$error || emailError.$error"
    />
    <SAIInput
      :disable="disable"
      class="q-mt-md"
      placeholder="Enter Employer Name"
      :large="true"
      :error="nameError.$error"
      :value="user.companyName"
      @input="$emit('update:user', { ...user, companyName: $event })"
    />
    <SAIInput
      class="q-mt-md"
      :disable="corporateAccountSignup || disable || user.noCorporateEmail"
      placeholder="Enter your work email"
      :large="true"
      type="email"
      :error="emailError.$error"
      :value="user.companyEmail"
      @input="$emit('update:user', { ...user, companyEmail: $event })"
    />
    <div>
      <SAICheckbox
        :disable="disable || user.noCorporateEmail"
        :val="true"
        class="full-width q-mt-md"
        label="I signed up with my work email"
        :value="corporateAccountSignup"
        @input="$emit('update:corporate-account-signup', $event)"
      />
      <SAICheckbox
        :disable="disable || corporateAccountSignup"
        class="full-width q-mt-sm"
        :val="true"
        label="I don't have a work email"
        :value="Boolean(user.noCorporateEmail)"
        @input="
          $emit('update:user', {
            ...user,
            companyEmail: null,
            noCorporateEmail: $event
          })
        "
      />
    </div>
    <QSpace />
    <div class="row justify-center q-mt-lg">
      <SAIBtn
        :disable="disable"
        :loading="loading"
        label="Next"
        icon-right="eva-arrow-forward-outline"
        :large="true"
        @click="$emit('next')"
      />
    </div>
  </div>
</template>

<script>
import { QSpace } from 'quasar';
import {
  SAIInput,
  SAICheckbox,
  SAIBtn,
  SAIFormError
} from 'ecx.saigon.ui.common';

export default {
  name: 'UserProfileEmployer',
  props: {
    disable: Boolean,
    loading: Boolean,
    corporateAccountSignup: Boolean,
    name: String,
    nameError: {
      type: Object,
      default: () => ({})
    },
    emailError: {
      type: Object,
      default: () => ({})
    },
    user: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    SAIInput,
    SAICheckbox,
    SAIBtn,
    SAIFormError,
    QSpace
  }
};
</script>
